module.exports = __webpack_public_path__ + "static/media/pdf-icon-2.2119e61a.png";